import { Label, Input } from "@educrib/firefly";
import FieldGroup from "./FieldGroup";

export default function Title({
  placeholder = "Title",
  label = true,
}: {
  placeholder?: string;
  label?: boolean;
}) {
  return (
    <FieldGroup>
      {label && <Label>{placeholder}</Label>}
      <Input type="text" name="title" placeholder={placeholder} />
    </FieldGroup>
  );
}
